import { useCallback } from "react";
import { useSSE } from "hooks/useSSE";
import { useThrottledRefresh } from "hooks/useThrottledRefresh";
import { toast } from "sonner";
import { log } from "utils/logger";
import MonitorPasoToast from "../components/MonitorPasoToast";

export function useMonitorPasosSSE({
    url,
    getBody,
    getHeaders,
    getDetalle,
    onRefresh,
    shouldRefresh,
    subscriptionKey,
    credentials,
    throttleMs = 15000,
}) {
    const { trigger, pendingCount, resetPendingCount } = useThrottledRefresh({
        ms: throttleMs,
        shouldRefresh,
        onRefresh,
    });

    const handleSSEMessage = useCallback(
        async (data, event) => {
            log.debug("📨 Evento recibido:", event.event);

            if (event.event === "conexion") {
                log.debug("🟢 SSE conectado");
                return;
            }

            if (event.event === "evento") {
                const { eventoId: migraUsuarioPasoId } = data;

                trigger();

                try {
                    const detalle = await getDetalle?.(migraUsuarioPasoId);
                    if (detalle && detalle.migraUsuarioPasoEstado !== "P") {
                        toast.custom(
                            (t) => <MonitorPasoToast t={t} detalle={detalle} credentials={credentials} />,
                            { duration: 5000 }
                        );
                    }
                } catch (err) {
                    log.error("Error obteniendo detalle del evento SSE:", err);
                }

                return;
            }

            log.debug("📨 Evento sin handler:", event.event);
        },
        [trigger, getDetalle, credentials]
    );

    const sseState = useSSE({
        url,
        getBody,
        getHeaders,
        onMessage: handleSSEMessage,
        subscriptionKey,
    });

    return {
        ...sseState,
        nuevosEventos: pendingCount,
        resetNuevosEventos: resetPendingCount,
    };
}
